import { Link } from 'react-router-dom';
import { API_BASE_URL, openInGoogleMaps } from '../../utils';
import './EventNewCard.css'
// import { IoRestaurant } from "react-icons/io5";
import { PiShareFatLight } from "react-icons/pi";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlinePushPin } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { FaDirections } from "react-icons/fa";

import { BiDrink } from "react-icons/bi";
import ShareModal from '../../Feed Page/custom-comp/ShareModal';
import { useState } from 'react';
import TextRoller from '../../My--Bidding--design/comp/TextRoller';
import { LuPartyPopper } from "react-icons/lu";

import { CiHeart } from "react-icons/ci";
import ReviewIMG from '../../Assets/artisht-profile.jpg';
import { HiOutlineLocationMarker } from "react-icons/hi";

const url = `${API_BASE_URL}/master/assets/uploads/`
export default function EventNewCard({ data, isFiltered }) {



    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [shareTitle, setShareTitle] = useState('');
    const [currentShareUrl, setCurrentShareUrl] = useState('');



    const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");
    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }

    function generateClubDetailUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }



    const packageMessages = [
        `Party smarter: Save ₹750 instantly`,
        `Great Choice! Save ₹750 Saved Instantly on This Booking!`,
    ];


    const generateEventUrl = (slug1, slug2) => {
        return `${API_BASE_URL}/event/${slug1}/${slug2}`;
    };

    const handleShare = (e, eventData) => {
        e.preventDefault();
        e.stopPropagation();
        let url;

        if (eventData.pricing) {
            url = `${API_BASE_URL}/carnival/${eventData.slug}`;
        } else {
            url = generateEventUrl(eventData.slug1, eventData.slug2);
        }


        setCurrentShareUrl(url);
        setShareTitle(`Check out ${eventData.clubName}${eventData.title ? " - " + eventData.title : ""}`);
        setIsShareModalOpen(true);
    };




    return (
        <>

            <div className='event-new-card'>
                <div className='event-new-card-image-section position-relative' style={{ backgroundImage: `url(${url + (data?.image || data?.icon)})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} >
                    <div className='event-detail-page-design-content1-img-blur-overlay'>

                        <div className='icon-seton-image'>
                            <div className='d-flex gap-2'>
                                <div className='pnats-icon-wrapper-icon-desktop icon cursor-pointer' onClick={(e) => handleShare(e, data)}>
                                    <CiHeart size={22} />
                                </div>
                                <div className='pnats-icon-wrapper-icon-mobile icon cursor-pointer ' onClick={(e) => handleShare(e, data)}>
                                    <PiShareFatLight size={22} />
                                </div>
                            </div>
                        </div>
                        <img
                            src={url + (data?.image || data?.icon)}
                            alt=""
                            onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGRyaW5rfGVufDB8fDB8fHww";
                            }}
                        />
                    </div>

                </div>
                <div className='event-new-card-image-section-wrapper '>

                    <div className='position-relative d-hide w-100'>
                        <div className='carnival-and-onwards d-flex'>
                            <div className='time-onwards-bid-new-card carnivaltag'>
                                <div className='carnival-set'>
                                    <p className='font-12'> <span>{data?.event_date}</span> | {data?.event_time} Onwards</p>
                                </div>

                                <svg xmlns="http://www.w3.org/2000/svg" width="240" height="38" viewBox="0 0 229 39" fill="none">
                                    <path d="M17.7019 3.24771C18.9861 1.22523 21.2154 0 23.6112 0H221.265C226.984 0 230.289 6.48618 226.929 11.1135L208.772 36.1135C207.455 37.9269 205.349 39 203.108 39H7.73677C2.21625 39 -1.13178 32.9081 1.82745 28.2477L17.7019 3.24771Z" fill="url(#paint0_linear_289_19074)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_289_19074" x1="-7.92517" y1="38.1727" x2="129.549" y2="-85.638" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#7464E4" />
                                            <stop offset="1" stop-color="#1A00D2" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            {data.pricing && (
                                <div className='time-onwards-bid-new-card carnivaltag'>
                                    <div className='carnival-set'>
                                        <h3><LuPartyPopper /> Carnival</h3>
                                    </div>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="107" height="39" viewBox="0 0 107 39" fill="none">
                                        <path d="M17.8992 3.11948C19.1972 1.17072 21.3837 0 23.7252 0H99.5811C105.034 0 108.393 5.95932 105.57 10.6245L90.4389 35.6245C89.1707 37.7199 86.8996 39 84.4503 39H7.0732C1.48363 39 -1.85137 32.7715 1.24727 28.1195L17.8992 3.11948Z" fill="url(#paint0_linear_457_24495)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_457_24495" x1="8.95255" y1="38.1727" x2="96.7899" y2="6.67625" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#1A00D2" />
                                                <stop offset="1" stop-color="#7464E4" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            )}
                        </div>
                    </div>



                    <div className='event-new-card-content-section'>
                        <div className='event-new-card-text-section-wrapper'>
                            <div className='event-new-card-text-section'>
                                <div className='d-flex align-items-center gap-2'>
                                    {data.pricing && (
                                        <div className='time-onwards-bid-new-card carnivaltag m-hide'>
                                            <div className='carnival-set'>
                                                <h3><LuPartyPopper /> Carnival</h3>
                                            </div>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="120" height="38" viewBox="0 0 107 39" fill="none">
                                                <path d="M96.7277 5.90995C94.8317 2.27751 91.0738 0 86.9762 0H11C4.92488 0 4.29153e-06 4.92487 4.29153e-06 11V28C4.29153e-06 34.0751 4.92487 39 11 39H95.8499C104.111 39 109.424 30.2335 105.601 22.9099L96.7277 5.90995Z" fill="url(#paint0_linear_1533_27076)" />
                                                <defs>
                                                    <linearGradient id="paint0_linear_1533_27076" x1="115.575" y1="38.1727" x2="7.02267" y2="-14.4788" gradientUnits="userSpaceOnUse">
                                                        <stop stop-color="#7464E4" />
                                                        <stop offset="1" stop-color="#1A00D2" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                    )}
                                    <h1 className='font-16'>{data?.name}</h1>
                                </div>


                                {/* <div className='d-flex gap-2 artist-profile-event'>
                                    <img className='' src={ReviewIMG}></img>
                                    <div className='d-flex flex-column gap-1 align-items-start'>
                                        <h4>Malvika Khanna <span></span></h4>
                                        <p>Artist</p>
                                    </div>
                                </div> */}


                                <div className='d-flex gap-2 align-items-center text-start'><span className='event-new-card-img-icon-section-logo'>
                                    <img
                                        src={data?.clubLogo ? url + data.clubLogo : url + data?.club.profile_pic}
                                        alt="club logo"
                                    />

                                </span> {data?.clubName || data?.name}
                                </div>






                                <div className='event-new-card-text-section-location'>
                                    <p><span className='icon-size-set'><HiOutlineLocationMarker /></span> {data?.clubAddress?.length > 24 ? data?.clubAddress?.slice(0, 24) + "..." : data?.clubAddress}</p>
                                    <div className='event-new-card-text-section-location-distance' onClick={() => openInGoogleMaps(data?.clubAddress)}>
                                        <span>
                                            <FaDirections />{" "}
                                            {data?.distance ? `${Math.round(Number(data.distance))} Kms` : "--"}
                                        </span>

                                    </div>
                                </div>



                                <h6 className='font-14'>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 22 20" fill="none">
                                            <path d="M18 5.5C18.5523 5.5 19 5.05228 19 4.5C19 3.94772 18.5523 3.5 18 3.5C17.4477 3.5 17 3.94772 17 4.5C17 5.05228 17.4477 5.5 18 5.5Z" fill="#070707" />
                                            <path d="M14 5.5C14.5523 5.5 15 5.05228 15 4.5C15 3.94772 14.5523 3.5 14 3.5C13.4477 3.5 13 3.94772 13 4.5C13 5.05228 13.4477 5.5 14 5.5Z" fill="#070707" />
                                            <path d="M15.99 7C14.61 7 13.49 7.84 13.49 8.88H18.49C18.49 7.84 17.37 7 15.99 7Z" fill="#070707" />
                                            <path d="M0 14C0 17.31 2.69 20 6 20C9.31 20 12 17.31 12 14V7H0V14ZM2 9H10V14C10 16.21 8.21 18 6 18C3.79 18 2 16.21 2 14V9Z" fill="#070707" />
                                            <path d="M10 0V5.5H12V2H20V7C20 9.21 18.21 11 16 11C15.05 11 14.19 10.65 13.5 10.1V12.45C14.26 12.8 15.11 13 16 13C19.31 13 22 10.31 22 7V0H10Z" fill="#070707" />
                                            <path d="M4 12.5C4.55228 12.5 5 12.0523 5 11.5C5 10.9477 4.55228 10.5 4 10.5C3.44772 10.5 3 10.9477 3 11.5C3 12.0523 3.44772 12.5 4 12.5Z" fill="#070707" />
                                            <path d="M8 12.5C8.55228 12.5 9 12.0523 9 11.5C9 10.9477 8.55228 10.5 8 10.5C7.44772 10.5 7 10.9477 7 11.5C7 12.0523 7.44772 12.5 8 12.5Z" fill="#070707" />
                                            <path d="M6 15.88C7.38 15.88 8.5 15.04 8.5 14H3.5C3.5 15.04 4.62 15.88 6 15.88Z" fill="#070707" />
                                        </svg>
                                    </span> &nbsp;
                                    {data?.categoryName || data?.entertainment}
                                </h6>



                            </div>
                           
                        </div>

                        <div className='event-new-card-about-text-section m-hide'>
                            <div className='pnats-icon-wrapper'>


                                {isFiltered && (
                                    <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon2'>
                                        <MdOutlineFilterAlt size={25} />
                                        <div className='pnats-icon-wrapper-icon pnats-icon-wrapper-icon3'>
                                            <MdOutlinePushPin size={10} />
                                        </div>
                                    </div>
                                )}
                            </div>



                            <div className='m-hide'>
                                <div className='PackageNewCard-about-text-section gap-2 '>
                                    <div className='time-onwards-bid-new-card '>
                                        <div className='set-content'>
                                            <h3>{data?.event_date}</h3>
                                            <p>{data?.event_time    } Onwards</p>
                                        </div>

                                        <svg xmlns="http://www.w3.org/2000/svg" width="162" height="65" viewBox="0 0 162 65" fill="none">
                                            <path d="M21.0506 6.39036C22.8486 2.4947 26.7476 0 31.0382 0H151C157.075 0 162 4.92487 162 11V54C162 60.0751 157.075 65 151 65H11.192C3.16431 65 -2.15962 56.6792 1.20445 49.3904L21.0506 6.39036Z" fill="url(#paint0_linear_1497_28152)" />
                                            <defs>
                                                <linearGradient id="paint0_linear_1497_28152" x1="-8.32161" y1="63.6212" x2="158.586" y2="-7.96047" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#7464E4" />
                                                    <stop offset="1" stop-color="#1A00D2" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    {data.pricing ? (
                        <Link to={`/carnival/${data?.slug}`} style={{ textDecoration: "none", width: "100%" }}>
                            <div className='event-new-card-text-section-button'>
                                <button className='m-hide'>View Details</button>
                                <div className='event-new-card-break-line'></div>
                                <div className='event-new-card-text-section-text-wrapper'>
                                    <TextRoller messages={packageMessages} />
                                </div>
                            </div>
                        </Link>
                    ) : (
                        <Link className='dispalyset' to={`/event/${data?.slug1}/${data?.slug2}`} style={{ textDecoration: "none", width: "100%" }}>
                            <div className='event-new-card-text-section-button'>
                                <button className='m-hide'>View Details</button>
                                <div className='event-new-card-break-line'></div>
                                <div className='event-new-card-text-section-text-wrapper'>
                                    <TextRoller messages={packageMessages} />
                                </div>
                            </div>
                        </Link>
                    )}

                    {data.pricing ? (
                        <Link to={`/carnival/${data?.slug}`} style={{ textDecoration: "none", width: "100%", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button className='btn text-btn d-hide'>View Details</button>
                        </Link>
                    ) : (
                        <Link className='dispalyset' to={`/event/${data?.slug1}/${data?.slug2}`} style={{ textDecoration: "none", width: "100%", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button className='btn text-btn d-hide'>View Details</button>
                        </Link>
                    )}


                </div>

            </div>

            <ShareModal
                isOpen={isShareModalOpen}
                onClose={() => setIsShareModalOpen(false)}
                shareUrl={currentShareUrl}
                title={shareTitle}
            />
        </>
    )
}
